import React from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';
import { Breadcrumb, message, Spin } from 'antd';
import { PageContainer } from '@ant-design/pro-layout';
import { useMutation, useQuery } from '@apollo/client';
import './style.less';
import RoleForm from './RoleForm';
import { UPDATE_ROLE, GET_ROLES } from '../../../gql/roles';
import {
  getScopesFromInput,
  getScopesForInitialValues,
} from '../../../utils/scopes';

const EditRole = () => {
  const { id } = useParams();
  const history = useHistory();
  const { data, loading } = useQuery(GET_ROLES, {
    variables: { ids: [id], state: 'ALL' },
  });
  const [updateRole, { loading: mutationLoading }] = useMutation(UPDATE_ROLE, {
    refetchQueries: [{ query: GET_ROLES, variables: { ids: [id] } }],
    onCompleted: ({ updateRole }) => {
      message.success(`${updateRole.name} successfully edited`);
      history.push('/system-setting/roles/');
    },
    onError: (err) => {
      console.log(err);
    },
  });

  if (loading) {
    return (
      <PageContainer
        header={{
          title: 'Edit Role',
        }}
        loading
      />
    );
  }

  return (
    <PageContainer
      header={{
        title: 'Edit Role',
        breadcrumb: (
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/system-setting/roles">Roles</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>{data.roles[0].name}</Breadcrumb.Item>
          </Breadcrumb>
        ),
      }}
      loading={loading}
    >
      <Spin spinning={mutationLoading} tip="Adding...">
        <RoleForm
          onFinish={(input) => {
            const scopes = getScopesFromInput(input);
            updateRole({
              variables: {
                updateRoleInput: {
                  id,
                  name: input.name,
                  description: input.description,
                  isDefaultRoleForNewUser: input.isDefaultRoleForNewUser,
                  reportControlType: input.reportControlType,
                  disabled: !input.active,
                  deleted: false,
                  scopes,
                },
              },
            });
          }}
          initialValues={
            loading
              ? {}
              : {
                  isDefaultRoleForNewUser:
                    data.roles[0].isDefaultRoleForNewUser,
                  name: data.roles[0].name,
                  description: data.roles[0].description,
                  reportControlType: data.roles[0].reportControlType,
                  active: !data.roles[0].disabled,
                  ...getScopesForInitialValues(data.roles[0].scopes),
                }
          }
          showDisable={true}
        />
      </Spin>
    </PageContainer>
  );
};

export default EditRole;
